import React from 'react';
import { Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useIsBreakpointDown } from '~/modules/common/hooks';
import { useInsightsSettings } from '../../hooks/useInsightsSettings';
import ResourceManagementDashboardContextProvider from '../../ResourceManagementDashboardContextProvider';
import ResourceManagementDashboardToolbar from '../ResourceManagementDashboardToolbar/ResourceManagementDashboardToolbar';
import { ActionItemsCard, BenchOverAllocationTrackerCard } from './components';
import ResourceManagementDashboardInsightsSkeleton from './ResourceManagementDashboardInsightsSkeleton';

const useStyles = makeStyles(theme => ({
  container: {
    padding: theme.spacing(1, 0, 1, 1.5),
    [theme.breakpoints.down('md')]: {
      paddingTop: 0
    }
  },
  trackerContainer: {
    minWidth: 0
  }
}));

export const ResourceManagementDashboardInsights = () => {
  const classes = useStyles();
  const isSMView = useIsBreakpointDown('sm');
  const { isLoading, insightsSettings } = useInsightsSettings();

  if (isLoading) {
    return <ResourceManagementDashboardInsightsSkeleton />;
  }

  return (
    <ResourceManagementDashboardContextProvider
      insightsSettings={insightsSettings}
    >
      <div className={classes.container}>
        <ResourceManagementDashboardToolbar />
        <Grid container spacing={2}>
          <Grid item xs={12} md className={classes.trackerContainer}>
            {isSMView && <ActionItemsCard />}

            <BenchOverAllocationTrackerCard />
          </Grid>

          {!isSMView && (
            <Grid item md="auto">
              <ActionItemsCard />
            </Grid>
          )}
        </Grid>
      </div>
    </ResourceManagementDashboardContextProvider>
  );
};

export default ResourceManagementDashboardInsights;
